import "./FooterContent.css";

export default function FooterContent({ children }) {
  return <div className="footer__content">{children}</div>;
}
